import { Routes } from '@angular/router';
import { VippsPaymentsComponent } from './vipps-payments.component';

export const VippsPaymentsRouteName = {
  Main: 'vipps-payments',
};

export const VIPPS_PAYMENTS_ROUTES: Routes = [
  {
    path: '',
    component: VippsPaymentsComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${VippsPaymentsRouteName.Main}`,
      },
    ],
  },
];
